// <LoginForm onSubmit={onLogin} onChange={onChange} formData={formData} />
import React, { useEffect, useState } from 'react';
import useAuth from '../../hooks/useAuth';
import { useParams } from 'react-router-dom';
import { createOtpApi, verifyOtpApi } from '../../api/account';
import OtpInput from '../../components/auth/login/OtpInput';
import LoginForm from '../../components/auth/login/LoginForm';

export const origin = {
  'http://localhost:3000': 'https://staging.iux.com',
  'https://tradedev.iux.com': 'https://staging.iux.com',
  'https://trading.iux.com': 'https://www.iux.com',
  'https://trading.iuxvn.com': 'https://www.iuxvn.com',
  'https://trading.id-iux.com': 'https://wwww.id-iux.com'
};

export const Login = ({ isMobile, noAcc }) => {
  const { login, authWithToken, getFirebaseCustom, logout, isOtp, reState } = useAuth();
  let { token = '' } = useParams();
  const [countDownOTP, setCountDownOTP] = useState(0);
  const [minutes, setMinutes] = useState(0);
  const [targetTime, setTargetTime] = useState(null);
  const [isErrorOtp, setIsErrorOtp] = useState(false);
  const [loadingOtp, setLoadingOtp] = useState(true);
  const [loading, setLoading] = useState(false);
  const [otp, setOtp] = useState('');
  const [loadingFooter, setLoadingFooter] = useState(true);
  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });
  const [otpData, setOtpData] = useState({
    reference: '',
    to: '',
    created: ''
  });
  const onLogin = async (payload) => {
    await login({
      username: payload.email,
      password: payload.password
    });
  };

  const onChange = (event) => {
    const { name, value } = event.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  useEffect(() => {
    (async () => {
      if (isOtp) {
        await handleCreateOtp();
      }
      // await logout();
    })();
  }, [isOtp]);

  useEffect(() => {
    if (token) {
      authWithToken({ token: token, loading: setLoading });
    }
  }, [token, setLoading]);

  const handleCreateOtp = async () => {
    try {
      setLoadingOtp(true);
      const { data } = await createOtpApi();
      setOtpData(data.data);
      setTargetTime(data.data?.created);
    } catch (e) {
      console.log('e', e);
    }
  };

  useEffect(() => {
    (async () => {
      if (isOtp) {
        await handleCreateOtp();
      }
      // await logout();
    })();
  }, [isOtp]);

  const countDownDuration = 3 * 60 * 1000; // 3 minutes in milliseconds

  useEffect(() => {
    const targetDate = new Date(targetTime);
    const endTime = new Date(targetDate?.getTime() + countDownDuration);
    const updateCountdown = () => {
      const now = new Date();
      const timeDiff = endTime?.getTime() - now?.getTime(); // Difference in milliseconds

      if (timeDiff <= 0) {
        clearInterval(myInterval);
        setMinutes(0);
        setCountDownOTP(0);
      } else {
        const remainingMinutes = Math.floor(timeDiff / (60 * 1000));
        const remainingSeconds = Math.floor((timeDiff % (60 * 1000)) / 1000);
        setMinutes(remainingMinutes);
        setCountDownOTP(remainingSeconds);
        setLoadingOtp(false);
      }
    };

    const myInterval = setInterval(updateCountdown, 1000);

    return () => {
      clearInterval(myInterval);
    };
  }, [targetTime]);

  const onChangeOtp = async (value) => {
    setOtp(value);
    if (value.replaceAll(' ', '').length === 6) {
      await verifyOtpApi({
        code: value,
        reference: otpData.reference
      })
        .then(({ data }) => {
          authWithToken({ token: data.data?.token, loading: setLoading });
          setIsErrorOtp(false);
        })
        .catch((e) => {
          console.log('e', e);
          setIsErrorOtp(true);
        });
    } else {
      setIsErrorOtp(false);
    }
  };
  const [isSuccess, setIsSuccess] = useState(false);

  if (!isMobile) {
    return (
      <>
        <div className="draggable"></div>
        {loading && loadingFooter && (
          <div
            className={`bg-[url(/public/img-landing2.svg)] z-10 w-full h-full bg-cover bg-center fixed left-0 top-0 transition-all`}>
            <div className="flex w-full h-full left-0 top-0 bg-[#00000075] z-10">
              <div className="m-auto">
                <div className="wrapper">
                  <div className="loading-text">
                    <h1 className="text-[#e5e5e5] text-2xl text-center">
                      LOADING
                      <span className="dot-one"> .</span>
                      <span className="dot-two"> .</span>
                      <span className="dot-three"> .</span>
                    </h1>
                    <div className="text-[#e5e5e5] text-center mt-2">
                      Please wait. Required data is being loaded.
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        {/* <div className='h-10 w-full bg-transparent fixed top-0 left-0 draggable'></div> */}
        <div className="">
          <div className="w-full flex mb-10">
            {!noAcc ? (
              <div className="w-full max-w-[450px] h-auto bg-[#242424] rounded-xl flex m-auto relative">
                <div className="absolute right-6 top-6">
                  <a
                    href={!isOtp ? 'https://www.iux.com/en/login' : '#'}
                    onClick={async () => {
                      if (isOtp) {
                        await logout();
                      }
                    }}>
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg">
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M5.29289 5.29289C5.68342 4.90237 6.31658 4.90237 6.70711 5.29289L12 10.5858L17.2929 5.29289C17.6834 4.90237 18.3166 4.90237 18.7071 5.29289C19.0976 5.68342 19.0976 6.31658 18.7071 6.70711L13.4142 12L18.7071 17.2929C19.0976 17.6834 19.0976 18.3166 18.7071 18.7071C18.3166 19.0976 17.6834 19.0976 17.2929 18.7071L12 13.4142L6.70711 18.7071C6.31658 19.0976 5.68342 19.0976 5.29289 18.7071C4.90237 18.3166 4.90237 17.6834 5.29289 17.2929L10.5858 12L5.29289 6.70711C4.90237 6.31658 4.90237 5.68342 5.29289 5.29289Z"
                        fill="white"
                      />
                    </svg>
                  </a>
                </div>
                {isOtp ? (
                  <div className="bg-[#2F2F2F] p-10 rounded-2xl h-[440px] w-full">
                    <div className="text-center">
                      <img
                        className="rounded-lg m-auto"
                        src="/iux-logo.png"
                        width="88px"
                        height="auto"
                        alt="..."
                      />
                      <div className="text-2xl text-[#e5e5e5] text-center mt-10 font-extrabold">
                        Verification Required
                      </div>
                      <div className="mt-4 max-w-[360px] leading-[19.12px]">
                        <span className="text-sm text-[#868686]">
                          Enter the code that was sent to {otpData.type}&nbsp;
                        </span>
                        <span className="text-sm text-[#11EF9E]">{otpData.to}&nbsp;</span>
                        <br />
                        <span className="text-sm text-[#868686]">Ref :&nbsp;</span>
                        <span className="text-sm text-[#868686]">{otpData.reference}</span>
                      </div>
                      <div className="flex mt-10 justify-center">
                        <OtpInput
                          value={otp}
                          valueLength={6}
                          onChange={onChangeOtp}
                          isError={isErrorOtp}
                          isSuccess={isSuccess}
                        />
                      </div>
                      {loadingOtp ? (
                        <div className="mt-4 flex">
                          <svg
                            version="1.1"
                            id="loader-1"
                            xmlns="http://www.w3.org/2000/svg"
                            xmlnsXlink="http://www.w3.org/1999/xlink"
                            x="0px"
                            y="0px"
                            width="40px"
                            height="40px"
                            viewBox="0 0 40 40"
                            enableBackground="new 0 0 40 40"
                            xmlSpace="preserve"
                            className="m-auto">
                            <path
                              opacity="0.2"
                              fill="#11EF9E"
                              d="M20.201,5.169c-8.254,0-14.946,6.692-14.946,14.946c0,8.255,6.692,14.946,14.946,14.946
                                  s14.946-6.691,14.946-14.946C35.146,11.861,28.455,5.169,20.201,5.169z M20.201,31.749c-6.425,0-11.634-5.208-11.634-11.634
                                  c0-6.425,5.209-11.634,11.634-11.634c6.425,0,11.633,5.209,11.633,11.634C31.834,26.541,26.626,31.749,20.201,31.749z"
                            />
                            <path
                              fill="#11EF9E"
                              d="M26.013,10.047l1.654-2.866c-2.198-1.272-4.743-2.012-7.466-2.012h0v3.312h0
                                  C22.32,8.481,24.301,9.057,26.013,10.047z">
                              <animateTransform
                                attributeType="xml"
                                attributeName="transform"
                                type="rotate"
                                from="0 20 20"
                                to="360 20 20"
                                dur="0.9s"
                                repeatCount="indefinite"
                              />
                            </path>
                          </svg>
                        </div>
                      ) : (
                        <div className="mt-4">
                          {minutes <= 0 && countDownOTP <= 0 ? (
                            <div
                              className="font-weight-bold cursor-pointer flex items-center justify-center"
                              onClick={() => handleCreateOtp()}>
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="17"
                                height="17"
                                viewBox="0 0 17 17"
                                fill="none">
                                <path
                                  fillRule="evenodd"
                                  clipRule="evenodd"
                                  d="M2.50065 1.83334C2.86884 1.83334 3.16732 2.13182 3.16732 2.50001V4.33335L4.05604 3.53104C5.23505 2.47579 6.79362 1.83334 8.50065 1.83334C12.1825 1.83334 15.1673 4.81811 15.1673 8.50001C15.1673 12.1819 12.1825 15.1667 8.50065 15.1667C5.32709 15.1667 2.67289 12.9498 1.99919 9.98087C1.91771 9.62181 2.14274 9.26468 2.5018 9.1832C2.86087 9.10173 3.21799 9.32676 3.29947 9.68582C3.83838 12.0608 5.96332 13.8333 8.50065 13.8333C11.4462 13.8333 13.834 11.4455 13.834 8.50001C13.834 5.55449 11.4462 3.16668 8.50065 3.16668C7.13476 3.16668 5.89018 3.67927 4.9463 4.52362L4.23399 5.16668H5.83398C6.20217 5.16668 6.50065 5.46515 6.50065 5.83334C6.50065 6.20153 6.20217 6.50001 5.83398 6.50001H2.50065C2.13246 6.50001 1.83398 6.20153 1.83398 5.83334V2.50001C1.83398 2.13182 2.13246 1.83334 2.50065 1.83334Z"
                                  fill="#11EF9E"
                                />
                              </svg>
                              <span className="text-[#11EF9E]">&nbsp;Resend Code</span>
                            </div>
                          ) : (
                            <>
                              <span className="text-[#868686] text-sm">
                                Haven’t Received it? Resend code in
                              </span>
                              <span className="font-extrabold text-[#11EF9E] text-sm">
                                &nbsp;{minutes < 10 ? `0${minutes}` : minutes}:
                                {countDownOTP < 10 ? `0${countDownOTP}` : countDownOTP}
                              </span>
                            </>
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                ) : (
                  <LoginForm onSubmit={onLogin} onChange={onChange} formData={formData} />
                )}
              </div>
            ) : (
              <div className="m-auto min-h-[400px] flex flex-col">
                <div className="m-auto">
                  <img className="m-auto" src="/images/none-account.svg" />
                  <p className="text-center my-4">You don’t have any accounts</p>
                  <div className="text-center">
                    <a
                      onClick={() => {
                        getFirebaseCustom().then((token) => {
                          window.location.href = `${origin[window.location.origin]
                            }/en/wallet/account/${token}`;
                        });
                      }}
                      href={`#`}>
                      <button className="transition-all bg-[#11EF9E] hover:bg-[#098a6c] rounded-lg border-none text-[#e5e5e5] px-3 py-2 font-[600] uppercase text-sm">
                        Go to Dashbaord
                      </button>
                    </a>
                    <div className="mt-4">
                      <a
                        href="#"
                        onClick={() => logout()}
                        className="text-[#11EF9E] text-sm hover:underline cursor-pointer">
                        Login another account
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </>
    );
  }
};
